import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/mark/Documents/use-date-input-patch/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useState } from 'react';
import { Playground } from "docz";
import { AnimatedGroup } from "@use-date-input/core";
import { DemoContent as AddYourComponentHere } from "../../gatsby-theme-docz/components/DemoContent";
import { Button } from "../../gatsby-theme-docz/components/Button";
import { ButtonBar } from "../../gatsby-theme-docz/components/ButtonBar";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "animatedgroup"
    }}>{`AnimatedGroup`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`AnimatedGroup`}</inlineCode>{` component animates it's children by the specified `}<inlineCode parentName="p">{`movement`}</inlineCode>{` in `}<inlineCode parentName="p">{`direction`}</inlineCode>{` for `}<inlineCode parentName="p">{`durationMsecs`}</inlineCode>{`.`}</p>
    <p>{`In the default implementation, `}<inlineCode parentName="p">{`AnimatedGroup`}</inlineCode>{` scrolls it's children, `}<inlineCode parentName="p">{`forward`}</inlineCode>{` or `}<inlineCode parentName="p">{`back`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Playground __position={0} __code={'() => {\n  const [direction, setDirection] = useState()\n  const [key, setKey] = useState()\n  function generateUID() {\n    return Math.random()\n      .toString(36)\n      .replace(/[^a-z]+/g, \'\')\n      .substr(2, 10)\n  }\n  function handleForwardClick() {\n    setDirection(\'forward\')\n    setKey(generateUID())\n  }\n  function handleBackClick() {\n    setDirection(\'back\')\n    setKey(generateUID())\n  }\n  return (\n    <>\n      <ButtonBar>\n        <Button\n          onClick={handleForwardClick}\n          variant=\"contained\"\n          color=\"primary\"\n        >\n          Back\n        </Button>\n        <Button onClick={handleBackClick} variant=\"contained\" color=\"primary\">\n          Forward\n        </Button>\n      </ButtonBar>\n      <div style={{ width: \'200px\', padding: \'8px\' }}>\n        <AnimatedGroup\n          direction={direction}\n          durationMsecs={5000}\n          movement={200}\n          transitionKey={key}\n        >\n          <AddYourComponentHere />\n        </AnimatedGroup>\n      </div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useState,
      Playground,
      AnimatedGroup,
      AddYourComponentHere,
      Button,
      ButtonBar,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        const [direction, setDirection] = useState();
        const [key, setKey] = useState();

        function generateUID() {
          return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(2, 10);
        }

        function handleForwardClick() {
          setDirection('forward');
          setKey(generateUID());
        }

        function handleBackClick() {
          setDirection('back');
          setKey(generateUID());
        }

        return <>
            <ButtonBar mdxType="ButtonBar">
                <Button onClick={handleForwardClick} variant="contained" color="primary" mdxType="Button">Back</Button>
                <Button onClick={handleBackClick} variant="contained" color="primary" mdxType="Button">Forward</Button>
            </ButtonBar>
            <div style={{
            width: "200px",
            padding: "8px"
          }}>
                <AnimatedGroup direction={direction} durationMsecs={5000} movement={200} transitionKey={key} mdxType="AnimatedGroup">
                    <AddYourComponentHere mdxType="AddYourComponentHere" />
                </AnimatedGroup>
            </div>
        </>;
      }}
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Prop Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Is Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`node`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Children`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`className`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class name of root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`direction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[forward, back]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Direction of animation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`durationMsecs`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`1200`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Duration of animation in msecs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`movement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pixel movement required`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onEnter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback called onEnter`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onExited`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`func`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback called onExited`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transitionKey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`required`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key for animation`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "importing"
    }}>{`Importing`}</h2>
    <p>{`It can be imported as either the base component`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { AnimatedGroup } from "@use-date-input/core";
`}</code></pre>
    <p>{`or as an overridable component that can be replaced through the `}<inlineCode parentName="p">{`components`}</inlineCode>{` prop in `}<inlineCode parentName="p">{`CalendarProvider`}</inlineCode>{`.`}<br parentName="p"></br>{`
`}{`Refer to `}<a parentName="p" {...{
        "href": "https://mark-tate.github.io/use-date-input/theming#how-to-replace-ui-components"
      }}>{`How to replace UI components`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import { CustomisableAnimatedGroup } from "@use-date-input/core";
`}</code></pre>
    <p>{`If providing your own component, it can be useful to import the base component and use it within your composition.  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      